/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for reordering problems in a workshop.
 * @export
 * @interface WorkshopProblemReorder
 */
export interface WorkshopProblemReorder {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopProblemReorder
     */
    problem_ids: Array<string>;
}

/**
 * Check if a given object implements the WorkshopProblemReorder interface.
 */
export function instanceOfWorkshopProblemReorder(value: object): value is WorkshopProblemReorder {
    if (!('problem_ids' in value) || value['problem_ids'] === undefined) return false;
    return true;
}

export function WorkshopProblemReorderFromJSON(json: any): WorkshopProblemReorder {
    return WorkshopProblemReorderFromJSONTyped(json, false);
}

export function WorkshopProblemReorderFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopProblemReorder {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_ids': json['problem_ids'],
    };
}

export function WorkshopProblemReorderToJSON(json: any): WorkshopProblemReorder {
    return WorkshopProblemReorderToJSONTyped(json, false);
}

export function WorkshopProblemReorderToJSONTyped(value?: WorkshopProblemReorder | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_ids': value['problem_ids'],
    };
}

